<template>
  <div class="agent-card-list-wrapper">
    <div class="agent-card-list">
      <!-- Create New Agent Card -->
      <div class="agent-card create-agent-card" @click="goToCreateAgent">
        <div class="create-agent-content">
          <div class="create-agent-icon">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
              <circle cx="20" cy="20" r="20" fill="#F5F5F5"/>
              <path d="M20 12v16M12 20h16" stroke="#6F2BFF" stroke-width="3" stroke-linecap="round"/>
            </svg>
          </div>
          <div class="create-agent-text">
            <span class="create-agent-title">Create New Agent</span>
          </div>
        </div>
      </div>
      <!-- Existing agent cards -->
      <AgentCard
        v-for="server in servers"
        :key="server.server_id"
        :server="server"
        :currentUserId="currentUserId"
        :currentUsername="currentUsername"
        :isHubAdmin="isHubAdmin"
        @delete="openDeleteConfirm"
        @copy-success="handleCopySuccess"
        @copy-error="handleCopyError"
      />
    </div>
    <ConfirmDeleteAgent
      v-if="showConfirm"
      :message="confirmMessage"
      @confirm="confirmDelete"
      @cancel="cancelDelete"
    />
  </div>
</template>

<script>

import AgentCard from './AgentCard.vue';
import ConfirmDeleteAgent from './ConfirmDeleteAgent.vue';
import { useToast } from 'vue-toastification';
import { apiFetch } from '@/services/api';
const toast = useToast();

export default {
  name: 'AgentCards',
  components: { AgentCard, ConfirmDeleteAgent },
  props: {
    servers: {
      type: Array,
      required: true
    },
    currentUserId: {
      type: String,
      default: ''
    },
    currentUsername: {
      type: String,
      default: ''
    },
    isHubAdmin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showConfirm: false,
      pendingDeleteId: null,
      confirmMessage: '',
      deletingAgentName: '',
    };
  },
  methods: {
    goToCreateAgent() {
      this.$router.push('/agents/new');
    },
    openDeleteConfirm(serverId) {
      const agent = this.servers.find(s => s.server_id === serverId);
      const agentName = agent ? agent.name : 'this Agent';
      this.confirmMessage =
        `Are you sure you want to permanently delete Agent "${agentName}"? ` +
        'This will remove all related data and cannot be undone.';
      this.pendingDeleteId = serverId;
      this.deletingAgentName = agentName;
      this.showConfirm = true;
    },
    async confirmDelete() {
      toast.info(`Deleting Agent "${this.deletingAgentName}"...`);
      const serverId = this.pendingDeleteId;
      const agentName = this.deletingAgentName;
      this.showConfirm = false;
      this.pendingDeleteId = null;
      try {
        const response = await apiFetch('/api/delete-server', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ server_id: serverId })
        });
        const data = await response.json().catch(() => ({}));

        if (!response.ok) {
          toast.error(data.detail || 'Failed to delete agent.');
        } else {
          this.$emit('deleted', { agentName, warnings: data.warnings || [] });
        }
      } catch (err) {
        toast.error('Failed to delete agent.');
      }
      this.deletingAgentName = '';
    },
    cancelDelete() {
      this.showConfirm = false;
      this.pendingDeleteId = null;
      this.deletingAgentName = '';
    },
    handleCopySuccess(serverName) {
      toast.success(`Embed code copied for ${serverName}!`);
    },
    handleCopyError() {
      toast.error('Failed to copy embed code to clipboard');
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/agent-cards.scss";
</style>